module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/group_8.ded2304.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/group_8.png
// module id = mdDF
// module chunks = 41